import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class FilesService {
  constructor(private http: HttpClient) {}

  downloadFile(fileName: string): Observable<Blob> {
    return this.http.get(`assets/files/${fileName}`, { responseType: 'blob' });
  }
}
